import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { provideNgIconLoader } from '@ng-icons/core';
import { MockApiInterceptor } from './interceptors/table-api-mock.interceptor';

const httpInterceptors = [authInterceptor, MockApiInterceptor];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors(httpInterceptors)),
    provideNgIconLoader(async (name: string) => {
      // Dynamically import all Iconoir icons
      const module: any = await import('@ng-icons/iconoir');

      // Convert `camera` → `IconoirCamera`
      const iconKey = 'iconoir' + name.charAt(0).toUpperCase() + name.slice(1);
      const icon = module[iconKey];
      if (icon) {
        return icon;
      }

      throw new Error(`Icon "${name}" not found in @ng-icons/iconoir`);
    }),
  ],
};
